const onLoadCallbacks = [];
const axios = require('axios');

const env = {
    onLoad(callback) {
        onLoadCallbacks.push(callback);
    }
};

let file;
if (process.env.VUE_APP_CONTEXT === 'production') {
    file = '/env_prod.json';
} else if (process.env.VUE_APP_CONTEXT === 'qa') {
    if (process.env.VUE_APP_BRANCH) {
        file = `/env_${process.env.VUE_APP_BRANCH}.json`;
    } else {
        file = '/env_qa.json';
    }
} else if (process.env.VUE_APP_CONTEXT === 'preview') {
    file = '/env_preview.json';
} else {
    file = '/env.json';
}

axios.get(file).then(res => {
    for (let key in res.data) {
        env[key] = res.data[key];
    }
    for (let callback of onLoadCallbacks) {
        callback(env);
    }
}).catch(err => {
    console.error(`Failed to load env.json: ${err.message}`);
});

export default env;